import { createFileRoute } from '@tanstack/react-router';
import CongregationEdit from '~/containers/CongregationEdit';

export const Route = createFileRoute('/congregations/$congregationId')({
  component: CongregationEdit,
  validateSearch(search): { from?: string } {
    return {
      from: (search.from as string) || undefined,
    };
  },
});
